const actions = {
    GET_CAJAS_REQUEST: 'GET_CAJAS_REQUEST',
    CREATE_TRASLADO_REQUEST: 'CREATE_TRASLADO_REQUEST',
    EDIT_CAJA_REQUEST: 'EDIT_CAJA_REQUEST',
    DELETE_CAJA_REQUEST: 'DELETE_CAJA_REQUEST',
    CREATE_TRASLADO_SUCCESS: 'CREATE_TRASLADO_SUCCESS',

    GET_CAJAS_SUCCESS: 'GET_CAJAS_SUCCESS',
    CREATE_CAJA_SUCCESS: 'CREATE_CAJA_SUCCESS',
    EDIT_CAJA_SUCCESS: 'EDIT_CAJA_SUCCESS',
    DELETE_CAJA_SUCCESS: 'DELETE_CAJA_SUCCESS',

    SAVE_RECIBO:'SAVE_RECIBO',
    GET_RECIBOS:'GET_RECIBOS',
    UPDATE_RECIBOS:'UPDATE_RECIBOS',
    UPDATE_RECIBO:'UPDATE_RECIBO',
    DELETE_RECIBO: 'DELETE_RECIBO',

    GET_EGRESOS:'GET_EGRESOS',
    SAVE_EGRESO:'SAVE_EGRESO',
    UPDATE_EGRESOS:'UPDATE_EGRESOS',
    UPDATE_EGRESO:'UPDATE_EGRESO',
    DELETE_EGRESO: 'DELETE_EGRESO',

    SET_PAGINATION_INFO: 'SET_PAGINATION_INFO',
    SET_RANGO: 'SET_RANGO',

    SET_PAGINATION_EGRESOS_INFO: 'SET_PAGINATION_EGRESOS_INFO',

    initDataCajas: () => ({ type: actions.GET_CAJAS_REQUEST }),
    createTraslado: (data, history) => ({
        type: actions.CREATE_TRASLADO_REQUEST,
        payload: data,
        history
    }),
    editCaja: data => ({
        type: actions.EDIT_CAJA_REQUEST,
        payload: data
    }),
    deleteCaja: id => ({
        type: actions.DELETE_CAJA_REQUEST,
        payload: id
    }),

    saveRecibo: (recibo, history) => ({ type: actions.SAVE_RECIBO, recibo, history }),
    getRecibos: (query) => ({ type: actions.GET_RECIBOS, query }),
    deleteRecibo: id => ({ type: actions.DELETE_RECIBO, id }),
    updateRecibo: (id,info) => ({ type: actions.UPDATE_RECIBO, id, info }),
    
    saveEgreso: (egreso, history) => ({ type: actions.SAVE_EGRESO, egreso, history }),
    getEgresos: (query) => ({ type: actions.GET_EGRESOS, query }),
    deleteEgreso: id => ({ type: actions.DELETE_EGRESO, id }),
    updateEgreso: (id,info) => ({ type: actions.UPDATE_EGRESO, id, info }),

    setRango: (startDate, endDate) => ({ type: actions.SET_RANGO, startDate, endDate }),

};
export default actions;